<div *ngIf="websiteBuilderService.spinnerShow && !websiteBuilderService.showCorporationsList" class="loader">
    <spinner [spinnerShow]="true"></spinner>
</div>
<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs website-builder"
     [ngClass]="{'sk-loading': websiteBuilderService.spinnerShow}">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="websiteBuilderService.showWebsiteBuilderView"
         [ngStyle]="{width: websiteBuilderService.showWebsiteBuilderView ? 'calc(100% - 460px)' : ''}"
         [ngClass]="{'fullscreen': websiteBuilderService.fullScreenPreview}">
        <div *ngIf="websiteBuilderService.showCorporationsList"
             class="ibox-content no-scroll-mode" style="overflow: auto">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Corporation'"></filter>
                </div>
                <!--<website-builder-filter></website-builder-filter>-->
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'websiteBuilder'"
                          [active]="true"
                          [ngClass]="{'sk-loading': websiteBuilderService.spinnerShow}">
                    <corporations-list></corporations-list>
                    <spinner [spinnerShow]="websiteBuilderService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="websiteBuilderService.data.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="websiteBuilderService.data.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
        <div *ngIf="websiteBuilderService.showWebsiteBuilderView"
             class="ibox-content no-scroll-mode no-padding" style="overflow: hidden;position: relative;">
            <button type="button" class="close-fullscreen-button btn btn-default"
                    *ngIf="websiteBuilderService.fullScreenPreview"
                    (click)="turnFullscreenModeOff()"
                    style="position:absolute;top:15px;right:30px;z-index: 9999;">
                <i class="fa fa-2x fa-compress" aria-hidden="true"></i>
            </button>
            <iframe class="web-view-frame" #webViewFrame (load)="onLoad()" style="width: 100%; height: 100%; border: 0; margin: 0;"></iframe>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar"
         *ngIf="websiteBuilderService.showWebsiteBuilderView && !websiteBuilderService.fullScreenPreview">
        <website-builder-side-editor (themeChange)="updateTheme($event)"></website-builder-side-editor>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder.component.html